<template>
  <div class="search-index">
    <b-nav-form @submit.stop.prevent="runSearch">
      <div class="search-bar-div" ref="searchBarDiv" contenteditable="true" @click="resetInput" @keydown="monitorEnter">
          <template v-for="(value, index) in searchDivText">
            <span contenteditable="true" :key="index" v-if="value.highlight && contentEditable" class="highlightspan highlight">{{value.content}}<span @click="deleteParam(index)" class="input-control"><fa icon="times"/></span></span>
            <span contenteditable="false" :key="index" v-if="value.highlight && !contentEditable" class="highlightspan highlight">{{value.content}}<span @click="deleteParam(index)" class="input-control"><fa icon="times"/></span></span>
          </template>
      </div>
      <b-button class="search-btn" @click="runSearch"><fa icon="search"/></b-button>
      <div v-show="showSelect" class='search-dropdown'>
        <ul class="options-list">
          <li v-for="(searchOption, index) in searchOptions" :key="index">
            <a href="#" @click="addToSearch(searchOption, false)">+</a>
            <a href="#" @click="addToSearch(searchOption, true)">{{searchOption}}</a>
          </li>
        </ul>
        <div class='date-picker' v-show="showDatePicker">
          <span v-show="showHint">{{datePickerHint}}</span>
          <datepicker :inline="true" @selected="setDate"></datepicker>
        </div>
      </div>
    </b-nav-form>
    <transition name="fade">
      <div v-if="loadingData === true" class="loading">
        <div class="loading-icon">
          <fa icon="sync-alt" spin/>
        </div>
        <div class="loading-text">
          Loading messages...
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="error === true" class="loading">
        <div class="loading-text">
          Error Loading Messages. Please Refresh.
        </div>
      </div>
    </transition>
    <div class="search-result">
      <table v-show="messages.length > 0 && loadingData === false" class="inbox-table" id="">
        <thead id="tbl-head">
          <tr>
            <th class="inboxname-column">
              <a href="#">Inbox</a>
            </th>
            <th class="customer-column">
              <a href="#">Customer</a>
            </th>
            <th class="conversation-column">
              <a href="#">Conversation</a>
            </th>
            <th class="message-id-column">
              <a href="#">Message ID</a>
            </th>
            <th class="user-column">
              <a href="#">User</a>
            </th>
            <th class="time-column">
              <a href="#">Last Updated</a>
            </th>
          </tr>
        </thead>
        <tbody id="tbl-body">
          <tr v-for="message in messages" :key="message.id">
            <td class="inboxname-column">
              {{message.attributes.inbox_name}}
            </td>
            <td class="customer-column">
              <router-link :to="{name: 'Message', params: { id: message.id } }">
                <span>
                  <template v-if="message.attributes.customer">
                    <span>{{message.attributes.customer}}</span>
                  </template>
                  <template v-else>
                    {{message.attributes.from}}
                  </template>
                </span>
              </router-link>
            </td>
            <td class="conversation-column">
              <router-link :to="{name: 'Message', params: { id: message.id } }">
                <span>
                  <span class="conversation-title">{{message.attributes.subject}}</span>
                  <p class="preview">{{message.attributes.preview_content}}</p>
                </span>
                </router-link>
            </td>
            <td class="message-id-column">
              <a href="#" >{{message.id}}</a>
            </td>
            <td class="user-column">
              <template v-if="getUser(message.attributes.user_id)">
                <img v-if="getUser(message.attributes.user_id).avatar_url" class="user-avatar" :src="getUser(message.attributes.user_id).avatar_url" v-b-tooltip.hover.left :title="getUser(message.attributes.user_id).full_name"/>
                <span v-else class="icon-missing">
                  <fa icon="user-circle"/>
                </span>
              </template>
            </td>
            <td class="time-column">
              <span v-b-tooltip.hover.left :title="detailedDate(message.attributes.last_thread_date)">
                {{prettyDate(message.attributes.last_thread_date)}}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="totals-row">
        <span class="total-conversation">{{totalMessages}}</span><span> total conversations | </span>
        <span class="viewing-text"> Viewing </span><span class="range1 viewing-text">{{ pageMin }}</span>
        <span class="viewing-text">-</span>
        <span class="range2 viewing-text">{{ pageMax }}</span>
      </div>
      <div class="pagination-row">
        <template v-if="page !== 1">
          <span class="all-previous" @click="setPage(1)"><span class="oi oi-chevron-left"></span><span class="oi oi-chevron-left"></span></span>&nbsp;
          <span class="previous" @click="setPage(page - 1)"><span class="oi oi-chevron-left" ></span></span>&nbsp;
        </template>
        <template v-if="pageMax < totalMessages">
          <span class="next" @click="setPage(page + 1)"><span class="oi oi-chevron-right"></span></span>&nbsp;
          <span class="all-next" @click="setPage(Math.ceil(totalMessages / perPage))"><span class="oi oi-chevron-right"></span><span class="oi oi-chevron-right"></span></span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { collectionsMixins } from '@/mixins/collectionsMixins'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import { helpersMixins } from '@/mixins/helpersMixins'
export default {
  name: 'Search',
  components: {
    Datepicker
  },
  mixins: [collectionsMixins, helpersMixins],
  data () {
    return {
      messages: [],
      active: 0,
      page: 1,
      totalMessages: 0,
      perPage: 50,
      links: {},
      pageMin: 0,
      pageMax: 0,
      searchString: '',
      showSelect: false,
      showDatePicker: false,
      showMultiDatePicker: false,
      statuses: ['active', 'pending', 'closed'],
      searchOptions: [],
      searchKey: '',
      mailboxes_collection: [],
      tags_collection: [],
      dateSelected: 0,
      showHint: false,
      datePickerHint: '',
      searchDivText: [],
      loadingData: false,
      error: false,
      spanIndexes: {},
      spanEditable: false
    }
  },

  created () {
    if (this.clients.length === 0) {
      this.$store.dispatch('loadClients')
    }
    if (this.$route.query.search_string) {
      this.searchString = this.$route.query.search_string
    } else {
      this.searchString = ''
    }
    if (this.searchString && this.searchString.length > 0) {
      this.runSearch()
    }
    this.loadCustomers()
    this.mailboxesCollection()
    this.tagsCollection()
  },

  computed: {
    ...mapGetters(['availableUsers', 'clients', 'customers']),
    contentEditable (index) {
      return this.spanEditable
    }
  },

  methods: {
    ...mapActions(['loadCustomers']),
    monitorEnter (e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.runSearch()
      }
    },
    getUser (userId) {
      let user = this.availableUsers.find(user => { return user.id === userId })
      if (user) {
        return user
      } else {
        return null
      }
    },
    resetInput () {
      let input = this.$refs.searchBarDiv
      let range = document.createRange()
      var sel = window.getSelection()
      var currentString = sel.anchorNode.data
      var searchNode = this.searchDivText.filter((n) => {
        if (n.content === currentString) {
          return n
        }
      })
      if (searchNode.length > 0 && !searchNode[0].highlight) {
        return false
      }
      let node = input.childNodes[input.childNodes.length - 1]
      if (!node) {
        return false
      }
      range.setStart(node, node.childNodes)
      range.collapse(true)
      sel.removeAllRanges()
      sel.addRange(range)
      this.spanEditable = false
    },
    setPage (num) {
      this.loadingData = true
      this.page = num
      this.runSearch()
    },
    deleteParam (index, event) {
      this.searchDivText.splice(index, 1)
      this.searchString = this.searchDivText.map(pair => pair.content).join(' ')
    },
    setDate (date) {
      let dateFormatted = moment(date).format('YYYY-MM-DD')
      if (!this.showHint) {
        this.searchString += '"' + dateFormatted + '"'
        this.showDatePicker = false
        this.showSelect = false
      } else if (this.dateSelected === 0) {
        this.searchString += '"' + dateFormatted + '&'
        this.dateSelected = 1
        this.datePickerHint = 'Select an end date'
      } else {
        this.searchString += dateFormatted + '"'
        this.dateSelected = 0
        this.showDatePicker = false
        this.showSelect = false
        this.showHint = false
      }
    },

    parseSearchString (string) {
      let reg = /(\w+):"(([^"]|"")*")/gi
      let arr = string.split(/([\w,:]+"[^"]*")/gi)
      let tmpArr = []
      arr.forEach(function (element) {
        if (reg.test(element)) {
          tmpArr.push({
            content: element,
            highlight: true
          })
        } else {
          tmpArr.push({
            content: element,
            highlight: false
          })
        }
      })
      return tmpArr
    },

    addToInputDiv (string) {
      this.searchDivText = this.parseSearchString(string)
    },

    addToSearchString (string) {
      this.searchString = this.parseSearchString(string)
    },
    addToSearch (value, hide) {
      if (this.searchString[this.searchString.length - 1] !== ':') {
        this.searchString += ','
      }
      this.searchString += '"' + value + '"'
      if (hide) {
        this.showSelect = false
      }
    },

    runSearch () {
      if (this.$refs.searchBarDiv) {
        this.searchString = this.$refs.searchBarDiv.innerText
      }
      this.$router.push({ query: { search_string: this.searchString } })
      this.loadingData = true
      this.$http.get('/search',
        { params: {
          search_string: this.searchString,
          page: this.page
        }
        })
        .then(response => this.searchSuccesfull(response.data))
        .catch(e => {
          console.log(e)
          this.loadingData = false
          this.error = true
        })
    },

    calcMinMax () {
      var newMin = (this.perPage * this.page) - this.perPage + 1
      if (this.messages.length > 0) {
        this.pageMin = newMin > 0 ? newMin : 1
      } else {
        this.pageMin = 0
      }
      var newMax = this.perPage * this.page
      if (newMax > this.totalMessages) {
        this.pageMax = this.totalMessages
      } else if (newMax < this.perPage) {
        this.pageMax = this.perPage
      } else {
        this.pageMax = this.perPage * this.page
      }
    },

    searchSuccesfull (response) {
      this.messages = response.messages.data
      this.totalMessages = response.total_messages
      this.calcMinMax()
      this.loadingData = false
      console.log(this.messages)
    },

    setKeys (searchKey) {
      this.spanEditable = true
      switch (searchKey) {
        case 'mailbox':
          this.searchOptions = this.mailboxes_collection.map(function (mailbox) {
            return mailbox.label
          })
          break
        case 'client':
          this.searchOptions = this.clients.map(client => client.label)
          break
        case 'customer':
          this.searchOptions = this.customers.map(customer => customer.email)
          break
        case 'assigned':
          this.searchOptions = this.availableUsers.map(function (user) {
            return user.first_name + ' ' + user.last_name
          })
          break
        case 'status':
          this.searchOptions = this.statuses
          break
        case 'tag':
          this.searchOptions = this.tags_collection.map(function (tag) {
            return tag.label
          })
          break
        case 'body':
        case 'subject':
        case 'id':
          this.searchString += '""'
          this.$nextTick(function () {
            let input = this.$refs.searchBarDiv
            let range = document.createRange()
            var sel = window.getSelection()
            let nodes = []
            input.childNodes.forEach(node => { if (node.tagName === 'SPAN') { nodes.push(node) } })
            let node = nodes[nodes.length - 1]
            if (!node) {
              return false
            }
            range.setStart(node.firstChild, node.firstChild.length - 1)
            range.collapse(true)
            sel.removeAllRanges()
            sel.addRange(range)
          })
          this.showSelect = false
          break
        case 'between':
          this.datePickerHint = 'Select a start date'
          this.showHint = true
          this.showDatePicker = true
          break
        case 'before':
        case 'after':
        case 'on':
          this.showDatePicker = true
          break
        default:
          break
      }
    }
  },

  mounted () {
    this.$root.$on('searchKeyClicked', (searchKey) => {
      this.showDatePicker = false
      this.showHint = false
      this.searchOptions = []
      this.showSelect = true
      this.searchString = this.$refs.searchBarDiv.innerText
      this.searchString += ' ' + searchKey + ':'
      this.setKeys(searchKey)
    })
  },
  watch: {
    searchString () {
      if (this.searchString && this.searchString.length) {
        this.addToInputDiv(this.searchString)
      }
    }
  }
}
</script>
<style scoped>
  #searchInput {
    margin-bottom: 0;
    border-color: #d6dde3;
    border-radius: 5px;
    height: 40px;
    transition: all .1s ease-in-out;
    -webkit-appearance: none;
    line-height: normal;
    padding: 0 55px;
    position: relative;
    background-color: transparent;
    -moz-appearance: none;
    appearance: none;
    border-color: #d5d5d5;
    border-radius: 30px;
    border-style: solid;
    border-width: 1px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    font-family: inherit;
    font-size: 1.5rem;
    line-height: 34px;
    overflow: hidden;
    margin: 0;
    outline: 0;
    padding: 0;
    position: relative;
    vertical-align: middle;
    width: 100%;
    margin: 8px;
    padding: 0 15px;
  }
  #searchDropdown  .v-select .dropdown-toggle::after {
    border-top: 0;
  }
  .dropdown-item {
    width: 100%;
    padding: 0;
  }
  .search-dropdown {
    box-sizing: border-box;
    box-shadow: 0 2px 4px rgba(180,192,202,.25), 0 8px 15px rgba(180,192,202,.25);
    border: 1px solid #d6dde3;
    border-radius: 3px;
    color: #adb1b5;
    margin-top: 4px;
    padding: 12px 24px;
    text-align: left;
    width: 100%;
  }
  .search-dropdown ul {
    list-style: none;
  }
  .search-dropdown a {
    color: #3197d6;
  }
.inbox-table {
  width: 100%;
  table-layout: fixed;
}
.inbox-table thead th {
  font-weight: 200;
  text-align: left;
  border-bottom: 1px solid #d6dde3;
}
.inbox-table th a {
  color: #93a1af;
}
.inbox-table td a {
  color: #4f5d6b;
}
.inbox-table tr.pending td a {
  color: #4f5d6b;
}
.inbox-table tr.active td a {
  font-weight: bold;
  color: #000;
}
.inbox-table tr.selected td {
  background: #fffcf1;
}
.inbox-table .preview {
  color: #93a1af;
  font-weight: 400;
}
.conversation-column a:hover {
  text-decoration: none;
}
.form-inline {
  max-width: 1200px;
  position: relative;
}
.conversation-column a .conversation-title:hover {
  text-decoration: underline;
}
td.conversation-column p, td.conversation-column span {
  line-height: 1.5em;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.inbox-table {
  font-size: .8rem;
}
.inbox-table .conversation-column {
  width: 50% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  padding-right: 20px;
}
.inbox-table td {
  text-align: left;
  border-bottom: 1px solid #d6dde3;
  padding: 5px 10px 5px 0;
}
.inbox-table .check-column {
  padding: 5px;
}
.inbox-table .customer-column {
  width: 15%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inbox-table .time-column {
  width: 13%;
}
.inbox-table .message-id-column {
  width: 10%;
}
.inbox-table .mailbox-column {
  width: 5%;
}
.inbox-table .user-column {
  width: 5%;
}
.reply-tag {
  background: #e2e2e2;
  border: 1px solid #cad0d6;
  color: #909ba5;
}
.topic-tag {
  padding: 0 5px;
}
.totals-row {
  float: left;
  color: #7a8da0;
}
.total-conversation, .total-active, .range1, .range2 {
  font-weight: bold;
  color: #676d7a;
}
.viewing-text {
  visibility: visible;
}
.pagination-row {
  float: right;
}
span.oi {
  color:#7a8da0;
}
.all-previous, .previous {
  visibility: visible;
}
.all-next, .next {
  visibility: visible;
}
.user-avatar {
  border-radius: 50%;
  height: 30px;
  width: 30px;
}
.icon-missing {
  color: #57B2CD;
  font-size: 30px;
}
.actions-wrapper {
  display: inline-block;
  background: #FFFFFF;
  height: 55px;
  padding: 0;
  border-radius: 5px;
  position: fixed;
  margin-left: -10%;
  border: 1px solid #DBDBDB;
  box-shadow: 0 10px 200px 10px rgba(0,0,0,.4);
}
.nav-closed .actions-wrapper {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
.nav-open .actions-wrapper {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
ul.inbox-actions {
  list-style: none;
  margin: 0;
  height: 54px;
  position: relative;
  margin: 0px;
  display: flex;
  justify-content: center;
  padding: 7px 5px;
  width: 100%;
}
.closed-tab > .nav-link {
  color: #6C757D;
}
.closed-tab > .nav-link.active {
  color: #FFF;
  background-color: #6C757D;
}
.search-btn {
    margin: 6px 5px;
    background: none;
    border: none;
    position: absolute;
    top: 0px;
    right: 5px;
    color: #57B2CD;
    outline: none;
}
.search-btn:active:focus {
  box-shadow: none !important;
}
.search-btn:active {
  background-color: transparent !important;
  color: #57B2CD !important;
}
.search-bar-div {
  font-size: 1.5rem;
  line-height: 34px;
  overflow: hidden;
  height: 32;
  text-align:left;
  border-color: #d6dde3;
  border-radius: 5px;
  transition: all .1s ease-in-out;
  -webkit-appearance: none;
  line-height: normal;
  padding: 0 55px;
  position: relative;
  background-color: transparent;
  -moz-appearance: none;
  appearance: none;
  border-color: #d5d5d5;
  border-radius: 30px;
  border-style: solid;
  border-width: 1px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  font-family: inherit;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  vertical-align: middle;
  width: 100%;
  margin: 8px;
  padding: 0 15px;

}
.highlight {
  background-color: #e4fbe6;
  box-shadow: 0 0 0 1px #a9e8ba;
  border-radius: 3px;
  padding: 2px 0;
}
.loading {
  height: 100vh;
  padding: 5vw;
  text-align: center;
  font-size: calc(~"15px + 1.5vw");
  background-color: #fff;
}
span.input-control {
  color: #7b6565;
  font-size: 11pt;
  z-index: 10;
}
.search-result {
  margin: 10px
}
.input-control {
  font-size: 10pt;
  color: #b53e3e;
  vertical-align: middle;
  text-align: center;
}
.search-index {
  margin: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue